var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('singleDateForm',{attrs:{"label":_vm.$t('dangerousGoods.dangerousGoodsList.form.safetyDataSheetDate'),"prependIcon":"event"},model:{value:(_vm.date),callback:function ($$v) {_vm.date=$$v},expression:"date"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }